import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { DwOrmDataService, DwOrmDataServiceToken } from '@devwareapps/devware-cap';
import { Inject } from '@angular/core';
import { TeamActivitySummary } from '../../models/team.models';
import { UserFitnessSummaryMetaData } from '../../../../meta-data/app-meta-data.service';

@Component({
    selector: 'app-team-activity-feed',
    templateUrl: './team-activity-feed.component.html',
    styleUrls: ['./team-activity-feed.component.scss']
})
export class TeamActivityFeedComponent implements OnChanges {

    @Input() challengeTeamId: number;
    @Input() challengeDefinitionId: number;

    summary: TeamActivitySummary;
    loading = false;

    private fitnessSummaryMeta = new UserFitnessSummaryMetaData();

    constructor(
        @Inject(DwOrmDataServiceToken) private ormDataService: DwOrmDataService,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['challengeTeamId'] && this.challengeTeamId) {
            this.loadActivity();
        }
    }

    private loadActivity() {
        this.loading = true;
        // Query UserFitnessSummary via ChallengeTeamMember -> UserChallenge join
        // TODO: Build full query using metadata query builder once UserFitnessSummary
        // relations to ChallengeTeamMember are confirmed in metadata
        this.loading = false;
    }
}
